var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconCaringPatients = function SvgIconCaringPatients(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#89C947"
    },
    d: "M483.316,301.286h-64.919c-8.106,2.88-16.614,4.398-25.3,4.398c-8.684,0-17.191-1.518-25.297-4.398 h-30.549c-3.377,5.861-9.694,9.824-16.932,9.824h-5.351c-0.405,0-0.759,0.25-0.914,0.619c-7.013,22.313-23.06,41.314-44.225,50.79 c-0.431,0.193-0.668,0.66-0.569,1.122c0.099,0.461,0.506,0.791,0.977,0.791h25.469c22.933,0,41.59,18.657,41.59,41.589v101.027 c0,2.179-1.773,3.952-3.952,3.952h-66.847c0.85,0.622,1.888,1,3.021,1h224.077c2.838,0,5.138-2.302,5.138-5.14V316.705 C498.733,308.203,491.819,301.286,483.316,301.286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2DFF9"
    },
    d: "M145.169,507.048V406.022c0-7.508,2.01-14.551,5.505-20.638c-4.218-3.257-9.499-5.202-15.228-5.202 h-10.533c-7.219,2.749-14.876,4.258-22.711,4.258c-7.91,0-15.65-1.468-22.983-4.258h-17.67c-13.767,0-24.968,11.199-24.968,24.965 v101.86c0,2.757,2.236,4.993,4.995,4.993H155.42c1.118,0,2.138-0.38,2.97-1h-9.269C146.942,511,145.169,509.228,145.169,507.048z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M79.844,380.41c-0.209-0.077-0.418-0.15-0.626-0.229h-17.67 c-13.767,0-24.968,11.199-24.968,24.965v101.86c0,2.757,2.236,4.993,4.995,4.993h21.626c-2.759,0-4.995-2.235-4.995-4.993v-101.86 C58.206,392.51,67.647,382.044,79.844,380.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB98A"
    },
    d: "M102.202,384.44c-6.528,0-12.938-1.011-19.104-2.925v8.225c0,10.686,8.662,19.349,19.349,19.349 s19.349-8.664,19.349-19.349v-8.46C115.503,383.325,108.919,384.44,102.202,384.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7931E"
    },
    d: "M102.202,228.999c18.209,0,34.829,3.234,47.508,10.616c1.938-2.568,4.729-4.495,8.038-5.329 c0.404-0.102,0.703-0.444,0.749-0.858c0.621-5.521,1.669-10.924,3.104-16.17c-12.976-15.843-34.736-23.984-59.4-23.984 c-39.766,0-72.002,21.141-72.002,61.643v29.946C30.2,244.361,62.436,228.999,102.202,228.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M52.65,240.866c5.949-28.112,29.978-44.097,60.061-47.075 c-3.432-0.34-6.939-0.517-10.509-0.517c-39.766,0-72.002,21.141-72.002,61.643v29.946C30.2,263.923,38.831,249.717,52.65,240.866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB98A"
    },
    d: "M31.2,308.502v-21.228h-7.848c-11.339,0-20.532,9.196-20.532,20.537 c0,11.343,9.193,20.537,20.532,20.537h10.522C32.132,321.865,31.2,315.184,31.2,308.502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD5B3"
    },
    d: "M172.825,322.941c-5.329-11.166-8.301-23.568-8.301-36.283v-18.915c0-0.552-0.448-1-1-1h-2.273 c-7.969,0-14.452-6.483-14.452-14.452v-4.002c0-3.706,1.413-7.141,3.786-9.732c-12.783-7.746-29.757-11.117-48.382-11.117 c-39.766,0-72.002,15.362-72.002,55.864v25.2c0,40.504,32.236,76.938,72.002,76.938C137.162,385.44,166.295,357.273,172.825,322.941 z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.218,308.502v-25.2c0-36.865,26.711-52.896,61.493-55.48c-3.432-0.254-6.939-0.384-10.509-0.384 c-39.766,0-72.002,15.362-72.002,55.864v25.2c0,40.504,32.236,76.938,72.002,76.938c3.57,0,7.077-0.305,10.509-0.869 C77.929,378.853,51.218,345.37,51.218,308.502z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#775436"
    },
    d: "M105.247,334.24h-7.704c-4.194,0-7.594-3.4-7.594-7.594s3.399-7.595,7.594-7.595h0.11v-9.938 c0-4.194,3.399-7.594,7.594-7.594c4.194,0,7.595,3.4,7.595,7.594v17.532C112.842,330.84,109.441,334.24,105.247,334.24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#775436"
    },
    d: "M136.311,322.481c-4.194,0-7.595-3.4-7.595-7.595v-10.765c0-4.194,3.4-7.594,7.595-7.594 c4.194,0,7.595,3.4,7.595,7.594v10.765C143.905,319.081,140.505,322.481,136.311,322.481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#775436"
    },
    d: "M68.584,322.481c-4.194,0-7.595-3.4-7.595-7.595v-10.765c0-4.194,3.4-7.594,7.595-7.594 c4.194,0,7.594,3.4,7.594,7.594v10.765C76.178,319.081,72.778,322.481,68.584,322.481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#775436"
    },
    d: "M102.447,364.388c-9.668,0-18.762-3.77-25.605-10.613c-2.965-2.966-2.965-7.774,0.001-10.74 c2.966-2.965,7.774-2.965,10.74,0c3.975,3.975,9.253,6.164,14.864,6.164c5.609,0,10.889-2.189,14.861-6.163 c2.967-2.966,7.774-2.966,10.74-0.002c2.967,2.965,2.967,7.773,0.002,10.74C121.208,360.618,112.115,364.388,102.447,364.388z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB98A"
    },
    d: "M164.523,286.658v-15.622h-2.385c-11.34,0-20.533,9.196-20.533,20.537 c0,11.344,9.193,20.537,20.533,20.537h6.458C165.944,303.87,164.523,295.264,164.523,286.658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB98A"
    },
    d: "M320.319,271.037h-2.376v15.622c0,8.605-1.421,17.211-4.073,25.452h6.449 c11.345,0,20.541-9.192,20.541-20.537C340.86,280.233,331.664,271.037,320.319,271.037z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB98A"
    },
    d: "M393.097,305.684c-7.879,0-15.613-1.251-23.034-3.63v15.395c0,13.052,10.579,23.631,23.632,23.631 c13.053,0,23.629-10.58,23.629-23.631v-15.771C409.541,304.314,401.398,305.684,393.097,305.684z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7931E"
    },
    d: "M438.062,82.185h-23.164c-8.441-6.719-19.122-10.744-30.75-10.744h-25.72 c-27.3,0-49.429,22.13-49.429,49.427V188.7c0-47.309,37.655-72.002,84.098-72.002c44.38,0,80.706,22.559,83.855,65.832 c0.147-1.357,0.248-2.726,0.248-4.119v-57.088C477.2,99.796,459.589,82.185,438.062,82.185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M358.428,71.441c-27.3,0-49.429,22.13-49.429,49.427v69.27 c0.013,0.02,0.025,0.041,0.037,0.061c0.39-21.062,8.33-37.538,21.214-49.234v-20.097c0-27.297,22.128-49.427,49.429-49.427 C379.679,71.441,358.428,71.441,358.428,71.441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB98A"
    },
    d: "M485.196,188.806H476.2v28.01c0,6.704-0.803,13.407-2.312,19.966h11.308 c13.244,0,23.985-10.738,23.985-23.988C509.182,199.547,498.441,188.806,485.196,188.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD5B3"
    },
    d: "M393.097,115.382c-46.442,0-84.098,24.693-84.098,72.002v2.817 c8.062,12.764,13.201,27.53,14.965,43.227c0.047,0.414,0.346,0.756,0.75,0.858c6.449,1.624,10.953,7.381,10.953,14.002v4.002 c0,7.131-5.196,13.057-11.998,14.228c15.151,23.76,40.595,40.166,69.428,40.166c46.448,0,84.104-42.556,84.104-89.868v-29.433 C477.2,140.075,439.545,115.382,393.097,115.382z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M323.964,233.428c0.047,0.414,0.346,0.756,0.75,0.858c3.646,0.918,6.668,3.158,8.608,6.127 c-2.046-7.603-3.148-15.529-3.148-23.597v-29.433c0-43.654,32.066-68.034,73.511-71.542c-3.471-0.294-6.999-0.459-10.589-0.459 c-46.442,0-84.098,24.693-84.098,72.002v2.817C317.061,202.964,322.2,217.731,323.964,233.428z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M335.646,247.794c0.006,0.165,0.022,0.328,0.022,0.494v4.002c0,7.131-5.196,13.057-11.998,14.228 c15.151,23.76,40.595,40.166,69.428,40.166c3.588,0,7.12-0.255,10.589-0.746C372.414,301.52,346.493,277.884,335.646,247.794z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#775436"
    },
    d: "M392.815,280.861c-10.505,0-21.007-3.997-29.004-11.995c-2.966-2.965-2.966-7.774,0-10.74 c2.966-2.965,7.774-2.965,10.74,0c10.069,10.07,26.456,10.069,36.529-0.001c2.966-2.966,7.774-2.964,10.74,0.001 c2.965,2.966,2.965,7.775-0.001,10.74C413.823,276.862,403.316,280.861,392.815,280.861z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#775436"
    },
    d: "M349.899,221.783c-7.68,0-14.902-2.993-20.337-8.428c-2.967-2.966-2.967-7.774-0.001-10.74 c2.967-2.966,7.775-2.967,10.739,0c2.567,2.566,5.977,3.98,9.599,3.98c3.621,0,7.028-1.413,9.595-3.979 c2.965-2.967,7.774-2.966,10.739-0.001c2.967,2.965,2.967,7.773,0.001,10.74C364.799,218.79,357.577,221.783,349.899,221.783z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#775436"
    },
    d: "M430.559,221.764c-7.365,0-14.73-2.803-20.337-8.408c-2.966-2.966-2.967-7.774-0.001-10.74 c2.964-2.967,7.773-2.967,10.74-0.001c5.292,5.291,13.901,5.292,19.193,0.001c2.965-2.966,7.773-2.966,10.739,0 s2.966,7.774,0,10.74C445.287,218.96,437.923,221.764,430.559,221.764z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#775436"
    },
    d: "M400.282,242.81h-5.027c-6.96,0-12.622-5.717-12.622-12.745v-15.962c0-4.194,3.4-7.594,7.595-7.594 c4.194,0,7.594,3.4,7.594,7.594v13.519h2.461c4.194,0,7.594,3.4,7.594,7.594C407.876,239.41,404.477,242.81,400.282,242.81z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M295.707,363.433h-27.963c-8.416,3.447-17.358,5.263-26.511,5.263s-18.096-1.815-26.512-5.263 h-27.962c-23.484,0-42.59,19.105-42.59,42.589v101.027c0,2.735,2.216,4.952,4.952,4.952h184.224c2.737,0,4.952-2.217,4.952-4.952 V406.022C338.297,382.538,319.191,363.433,295.707,363.433z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M165.345,507.048V406.022c0-23.483,19.105-42.589,42.59-42.589h-21.176c-23.484,0-42.59,19.105-42.59,42.589v101.027 c0,2.735,2.216,4.952,4.952,4.952h21.177C167.561,512,165.345,509.783,165.345,507.048z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB98A"
    },
    d: "M241.233,368.695c-11.721,0-23.101-2.967-33.464-8.553l28.795,56.628c2.568,5.05,6.771,5.05,9.339,0 l28.794-56.628C264.334,365.728,252.955,368.695,241.233,368.695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB8276"
    },
    d: "M220.848,153.837c6.53-1.844,13.355-2.837,20.385-2.837s13.854,0.993,20.383,2.836 c6.627-6.42,10.833-15.898,10.833-26.462c0-2.177-1.764-3.941-3.939-3.941h-54.556c-2.176,0-3.939,1.765-3.939,3.941 C210.015,137.939,214.221,147.417,220.848,153.837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M220.848,153.837c6.007-1.696,12.269-2.648,18.707-2.792 c-5.128-6.235-8.279-14.542-8.279-23.67c0-2.177,1.764-3.941,3.939-3.941h-21.262c-2.176,0-3.939,1.765-3.939,3.941 C210.015,137.939,214.221,147.417,220.848,153.837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD5B3"
    },
    d: "M163.523,266v20.658c0,43.715,34.79,83.037,77.71,83.037c42.916,0,77.71-39.322,77.71-83.037V266 H163.523z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M185.057,286.658V266h-21.533v20.658c0,43.715,34.79,83.037,77.71,83.037c3.655,0,7.245-0.307,10.766-0.855 C214.179,362.944,185.057,326.65,185.057,286.658z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#775436"
    },
    d: "M201.403,302.953c-7.271,0-14.109-2.834-19.256-7.981c-2.966-2.966-2.965-7.774,0.001-10.74 c2.966-2.965,7.775-2.965,10.74,0.001c2.277,2.277,5.301,3.532,8.515,3.532c3.213,0,6.237-1.254,8.515-3.532 c2.967-2.965,7.773-2.966,10.74,0c2.966,2.966,2.966,7.774,0.001,10.74C215.513,300.119,208.674,302.953,201.403,302.953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#775436"
    },
    d: "M276.235,302.953c-7.27,0-14.109-2.834-19.255-7.981c-2.965-2.966-2.965-7.775,0.002-10.741 c2.965-2.965,7.772-2.964,10.739,0.001c2.277,2.277,5.301,3.532,8.514,3.532c3.214,0,6.239-1.255,8.518-3.533 c2.967-2.965,7.773-2.964,10.739,0.001c2.966,2.966,2.966,7.775-0.001,10.741C290.344,300.119,283.506,302.953,276.235,302.953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#775436"
    },
    d: "M248.146,322.461h-4.665c-6.759,0-12.259-5.717-12.259-12.745v-14.437 c0-4.194,3.4-7.594,7.595-7.594c4.194,0,7.595,3.4,7.595,7.594v11.994h1.734c4.194,0,7.594,3.4,7.594,7.594 S252.341,322.461,248.146,322.461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#775436"
    },
    d: "M241.232,352.407c-10.132,0-20.261-3.855-27.975-11.569c-2.966-2.966-2.966-7.774,0-10.74 c2.967-2.966,7.775-2.966,10.74,0c9.503,9.504,24.968,9.502,34.471-0.001c2.967-2.965,7.774-2.964,10.74,0.001 c2.966,2.966,2.966,7.774-0.001,10.741C261.496,348.55,251.363,352.407,241.232,352.407z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF5050"
    },
    d: "M161.25,234h159.966c1.336,0,2.626,0.19,3.864,0.512c-4.841-47.825-40.53-84.961-83.847-84.961 c-43.319,0-79.01,37.137-83.851,84.962C158.622,234.19,159.913,234,161.25,234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M161.25,234h17.212c4.629-43.653,34.959-78.296,73.276-83.709 c-3.442-0.486-6.947-0.74-10.505-0.74c-43.319,0-79.01,37.137-83.851,84.962C158.622,234.19,159.913,234,161.25,234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB8276"
    },
    d: "M336.667,252.291c0,8.499-6.953,15.452-15.451,15.452H161.25c-8.499,0-15.452-6.954-15.452-15.452 v-4.002c0-8.499,6.953-15.453,15.452-15.453h159.966c8.498,0,15.451,6.954,15.451,15.453V252.291z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M167.405,252.291v-4.002c0-8.499,6.953-15.453,15.453-15.453H161.25c-8.499,0-15.452,6.954-15.452,15.453v4.002 c0,8.499,6.953,15.452,15.452,15.452h21.608C174.358,267.743,167.405,260.789,167.405,252.291z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#046699"
    },
    d: "M136.001,454.425H68.144c-1.122,0-2.104-0.984-2.104-2.104v-28.614 c0-8.136-6.592-14.729-14.728-14.729c-8.135,0-14.73,6.593-14.73,14.729v28.614c0,17.404,14.159,31.562,31.562,31.562h67.857 C136.001,479.12,136.001,464.108,136.001,454.425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD5B3"
    },
    d: "M134.232,484.933c0-4.092,0-34.554,0-38.645c0-6.268,5.063-11.347,11.306-11.344l9.21-0.003 c6.243,0.003,11.304,5.079,11.304,11.347c0,4.089-2.167,7.665-5.404,9.661c3.235,1.994,5.404,5.569,5.404,9.661 s-2.167,7.669-5.405,9.66c3.238,1.997,5.405,5.57,5.405,9.664c0,6.264-5.061,11.343-11.304,11.343h-9.21 C139.297,496.274,134.232,491.197,134.232,484.933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#368C0E"
    },
    d: "M478.763,332.518c-11.031,0-19.973,8.941-19.973,19.972l0.014,95.809 c-0.01,0.021-0.041,0.055-0.021,0.059h-98.779c0,9.037,0,35.74,0,39.945h98.787c22.025,0,39.943-17.92,39.943-39.945V352.49 C498.733,341.459,489.792,332.518,478.763,332.518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48C1E1"
    },
    d: "M285.494,482.875c-1.632,0-2.96-1.327-2.96-2.958v-18.095h-18.108c-1.634,0-2.958-1.327-2.958-2.958 V443.55c0-1.63,1.324-2.956,2.958-2.956h18.108v-18.097c0-1.631,1.328-2.959,2.96-2.959h15.325c1.632,0,2.957,1.328,2.957,2.959 v18.097h18.109c1.632,0,2.959,1.326,2.959,2.956v15.314c0,1.631-1.327,2.958-2.959,2.958h-18.109v18.095 c0,1.631-1.325,2.958-2.957,2.958H285.494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD5B3"
    },
    d: "M361.377,445.86c0,4.503,0,38.011,0,42.513c0,6.892-5.567,12.479-12.436,12.475l-10.129,0.004 c-6.871-0.004-12.435-5.587-12.436-12.479c0-4.5,2.386-8.434,5.945-10.628c-3.558-2.195-5.945-6.127-5.945-10.626 c0-4.501,2.386-8.436,5.945-10.628c-3.56-2.195-5.945-6.125-5.945-10.629c0-6.892,5.565-12.476,12.436-12.476h10.129 C355.81,433.386,361.377,438.968,361.377,445.86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB8276"
    },
    d: "M143.303,134.348c-1.814,0-3.516-0.704-4.798-1.979L85.747,79.876 c-6.36-6.329-9.862-14.754-9.862-23.725c0-8.967,3.502-17.393,9.862-23.722c6.37-6.338,14.837-9.828,23.844-9.828 c9.009,0,17.476,3.49,23.845,9.828l10.062,10.01l10.066-10.01c6.362-6.338,14.833-9.828,23.84-9.828 c9.008,0,17.476,3.49,23.844,9.828c6.366,6.336,9.878,14.762,9.878,23.722c0,8.962-3.512,17.388-9.882,23.725l-53.159,52.509 C146.807,133.648,145.105,134.348,143.303,134.348z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M107.215,69.123c-6.359-6.329-9.861-14.755-9.861-23.726c0-8.458,3.118-16.435,8.812-22.624 c-7.713,0.769-14.863,4.129-20.418,9.656c-6.36,6.329-9.862,14.755-9.862,23.722c0,8.971,3.502,17.396,9.862,23.725l52.758,52.493 c1.282,1.275,2.984,1.979,4.798,1.979c1.803,0,3.504-0.699,4.781-1.962l11.397-11.258L107.215,69.123z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC502"
    },
    d: "M282.86,70.581c-1.337,0-2.502-0.916-2.809-2.213c-5.146-21.767-8.56-25.164-30.435-30.284 c-1.303-0.304-2.225-1.462-2.225-2.794c0-1.333,0.922-2.49,2.225-2.795c21.875-5.12,25.288-8.518,30.435-30.283 C280.358,0.917,281.523,0,282.86,0c1.339,0,2.502,0.917,2.808,2.212c5.148,21.766,8.56,25.164,30.435,30.283 c1.301,0.305,2.225,1.462,2.225,2.795c0,1.332-0.924,2.49-2.225,2.794c-21.876,5.12-25.287,8.517-30.435,30.284 C285.362,69.665,284.199,70.581,282.86,70.581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC502"
    },
    d: "M41.396,165.333c-1.338,0-2.502-0.916-2.809-2.213c-5.146-21.767-8.56-25.164-30.436-30.284 c-1.302-0.304-2.223-1.461-2.223-2.794s0.921-2.49,2.223-2.794c21.876-5.12,25.29-8.518,30.436-30.284 c0.307-1.296,1.471-2.212,2.809-2.212c1.338,0,2.503,0.916,2.809,2.212c5.146,21.766,8.559,25.163,30.435,30.284 c1.303,0.305,2.225,1.462,2.225,2.794s-0.922,2.49-2.225,2.794c-21.876,5.12-25.288,8.518-30.435,30.284 C43.899,164.417,42.734,165.333,41.396,165.333z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCaringPatients, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-caring-patients.f5eecb71.svg";
export { ForwardRef as ReactComponent };